import { useCallback } from 'react';
import { usePermissions } from './usePermissions';

export const useReportPermissions = () => {
  const { hasPermission } = usePermissions();

  // التحقق من صلاحية الوصول لصفحة تقرير معينة
  const hasReportPagePermission = useCallback((pageId: string, action: string = 'view_page') => {
    return hasPermission('reports', pageId, action);
  }, [hasPermission]);

  // التحقق من صلاحية تصدير الإكسل لتقرير معين
  const hasReportExportPermission = useCallback((pageId: string) => {
    return hasPermission('reports', pageId, 'export_excel');
  }, [hasPermission]);

  // التحقق من صلاحية الطباعة لتقرير معين
  const hasReportPrintPermission = useCallback((pageId: string) => {
    return hasPermission('reports', pageId, 'print');
  }, [hasPermission]);

  return {
    hasReportPagePermission,
    hasReportExportPermission,
    hasReportPrintPermission
  };
};